export default __webpack_public_path__ + "static/media/laptop.09265779.svg";